var t=function(n){return typeof n=="function"};export{t as isFunction};
//# sourceMappingURL=index.js.map
